<template>
  <div class="detail-container">
    <div class="top">
      <span class="title">敬献详情</span>
      <i class="close-icon iconfont" @click="closeDetail">&#xe69f;</i>
    </div>
    <div class="detail-box">
      <div class="left">
        <img :src="$resUrl(detailInfo.picturePath)" alt="">
      </div>
      <div class="right">
        <div class="item">
          <span class="key">名称：</span>
          <span class="value">{{ detailInfo.name }}</span>
        </div>
        <div class="item">
          <span class="key">敬献标号：</span>
          <span class="value">{{ detailInfo.sacrificesGoodsId }}</span>
        </div>
        <div class="item">
          <span class="key">敬献人：</span>
          <span class="value">{{ detailInfo.offerName }}</span>
        </div>
        <div v-if="detailInfo.createdDate" class="item">
          <span class="key">敬献时间：</span>
          <span class="value">{{ formatTime(detailInfo.createdDate) }}</span>
        </div>
        <div class="item">
          <span class="key">剩余时间：</span>
          <span v-show="detailInfo.isOverdue" class="value red">已过期</span>
          <span v-show="!detailInfo.isOverdue" class="value">{{ detailInfo.surplusTime }}</span>
        </div>
        <div class="item">
          <span class="key">敬献留言：</span>
          <span class="value">{{ detailInfo.content }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RecordDetail',
  props: {
    detailInfo: {
      type: Object,
      default: () => {
      }
    }
  },
  methods: {
    formatTime(time) {
      const times = time
      // console.log(times, 'timessss')
      let times1 = times.split(' ')[0]
      let times2 = times.split(' ')[1]
      times1 = times1.split('-')[0] + '/' + times1.split('-')[1] + '/' + times1.split('-')[2]
      times2 = times2.split(':')[0] + ':' + times2.split(':')[1]
      const allTime = times1 + ' ' + times2
      return allTime
    },
    closeDetail() {
      this.$emit('close')
    }
  }
}
</script>

<style lang='scss' scoped>
.detail-container {
  .top {
    position: relative;
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #ebebeb;
    text-align: center;
    box-sizing: border-box;

    .title {
      font-size: 16px;
      color: #000;
      font-weight: bold;
    }

    .close-icon {
      position: absolute;
      right: 15px;
      font-size: 14px;
      color: #7f7f7f;
    }
  }

  .detail-box {
    height: 200px;
    display: flex;
    padding: 5px 8px;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    // overflow-y: auto;
    .left {
      width: 100px;
      height: 100px;
      background: url('~@/assets/images/record-avator-bg.png') no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 84%;
        height: 84%;
      }
    }

    .right {
      flex: 1;
      padding-left: 5px;
      display: flex;
      flex-flow: column;
      justify-content: space-between;
      max-height: 100%;
      overflow-y: auto;

      .item {
        display: flex;
        align-items: center;
        font-size: 12px;
        line-height: 1.4;

        .key {
          display: inline-block;
          width: 72px;
          text-align: right;
          color: $primary-color;
        }

        .value {
          flex: 1;
        }

        .red {
          color: #ed1010;
        }
      }
    }
  }
}
</style>
